

 if($('.brand_slider').length > 0){
    $('.brand_slider').slick({
          slidesToShow:5,
          slidesToScroll: 5,
          rows:2,
          dots: true,    		
          speed: 1000,        
          // appendArrows: ".slider-arrows-dots",
          arrows: false,
             prevArrow: '<div title="Previous" class="custom-left custom-arrow trans"><svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.5303 0.307561C8.82319 0.600454 8.82319 1.07533 8.5303 1.36822L2.0103 7.88822C1.53319 8.36533 1.53319 9.15045 2.0103 9.62756L8.5303 16.1476C8.82319 16.4405 8.82319 16.9153 8.5303 17.2082C8.2374 17.5011 7.76253 17.5011 7.46964 17.2082L0.949636 10.6882C-0.113257 9.62533 -0.113258 7.89045 0.949636 6.82756L7.46964 0.307561C7.76253 0.0146673 8.2374 0.0146673 8.5303 0.307561Z" fill="#000"/></svg></div>',
          nextArrow: '<div title="Next" class="custom-right custom-arrow trans"><svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.379582 0.307561C0.672475 0.0146673 1.14735 0.0146673 1.44024 0.307561L7.96024 6.82756C9.02314 7.89045 9.02314 9.62533 7.96024 10.6882L1.44024 17.2082C1.14735 17.5011 0.672475 17.5011 0.379582 17.2082C0.0866888 16.9153 0.0866888 16.4405 0.379582 16.1476L6.89958 9.62756C7.37669 9.15045 7.37669 8.36533 6.89958 7.88822L0.379582 1.36822C0.0866888 1.07533 0.0866888 0.600454 0.379582 0.307561Z" fill="#000"/></svg></div>', 
          autoplay: false,
          infinite: true,
          autoplaySpeed: 3000,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 4, 
                slidesToScroll: 4
              }
            },
            {
              breakpoint: 666,
              settings: {
                slidesToShow: 3, 
                slidesToScroll: 3
              }
            }
          ,{
              breakpoint: 566,
              settings: {
                slidesToShow: 2, 
                slidesToScroll: 2
              }
            }
        ]
      });
 }

if($('.TopSelling').length > 0){
  $(' .TopSelling').slick({               
      slidesToShow:5,
      slidesToScroll: 5,
      dots: false,    		
      speed: 1000,        
      // appendArrows: ".slider-arrows-dots",
       arrows: true,
           prevArrow: '<div title="Previous" class="custom-left custom-arrow trans"><svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.5303 0.307561C8.82319 0.600454 8.82319 1.07533 8.5303 1.36822L2.0103 7.88822C1.53319 8.36533 1.53319 9.15045 2.0103 9.62756L8.5303 16.1476C8.82319 16.4405 8.82319 16.9153 8.5303 17.2082C8.2374 17.5011 7.76253 17.5011 7.46964 17.2082L0.949636 10.6882C-0.113257 9.62533 -0.113258 7.89045 0.949636 6.82756L7.46964 0.307561C7.76253 0.0146673 8.2374 0.0146673 8.5303 0.307561Z" fill="#000"/></svg></div>',
       nextArrow: '<div title="Next" class="custom-right custom-arrow trans"><svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.379582 0.307561C0.672475 0.0146673 1.14735 0.0146673 1.44024 0.307561L7.96024 6.82756C9.02314 7.89045 9.02314 9.62533 7.96024 10.6882L1.44024 17.2082C1.14735 17.5011 0.672475 17.5011 0.379582 17.2082C0.0866888 16.9153 0.0866888 16.4405 0.379582 16.1476L6.89958 9.62756C7.37669 9.15045 7.37669 8.36533 6.89958 7.88822L0.379582 1.36822C0.0866888 1.07533 0.0866888 0.600454 0.379582 0.307561Z" fill="#000"/></svg></div>', 
      autoplay: false,
      infinite: true,
      autoplaySpeed: 3000,
      responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4, 
              slidesToScroll: 4
            }
          },
        {
            breakpoint: 767,
            settings: {
              slidesToShow: 3, 
              slidesToScroll: 3
            }
          },
        {
            breakpoint: 566,
            settings: {
              slidesToShow: 2, 
              slidesToScroll: 2
            }
          } ,{
              breakpoint: 400,
              settings: {
                slidesToShow: 1, 
                slidesToScroll: 1
              }
            }
      
    ]
  });
}

if($('.cat_focus').length > 0){
    $('.cat_focus').slick({
          slidesToShow:5,
          slidesToScroll: 5, 
          dots: true,    		
          speed: 1000,        
          // appendArrows: ".slider-arrows-dots",
          arrows: false,
             prevArrow: '<div title="Previous" class="custom-left custom-arrow trans"><svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.5303 0.307561C8.82319 0.600454 8.82319 1.07533 8.5303 1.36822L2.0103 7.88822C1.53319 8.36533 1.53319 9.15045 2.0103 9.62756L8.5303 16.1476C8.82319 16.4405 8.82319 16.9153 8.5303 17.2082C8.2374 17.5011 7.76253 17.5011 7.46964 17.2082L0.949636 10.6882C-0.113257 9.62533 -0.113258 7.89045 0.949636 6.82756L7.46964 0.307561C7.76253 0.0146673 8.2374 0.0146673 8.5303 0.307561Z" fill="#000"/></svg></div>',
          nextArrow: '<div title="Next" class="custom-right custom-arrow trans"><svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.379582 0.307561C0.672475 0.0146673 1.14735 0.0146673 1.44024 0.307561L7.96024 6.82756C9.02314 7.89045 9.02314 9.62533 7.96024 10.6882L1.44024 17.2082C1.14735 17.5011 0.672475 17.5011 0.379582 17.2082C0.0866888 16.9153 0.0866888 16.4405 0.379582 16.1476L6.89958 9.62756C7.37669 9.15045 7.37669 8.36533 6.89958 7.88822L0.379582 1.36822C0.0866888 1.07533 0.0866888 0.600454 0.379582 0.307561Z" fill="#000"/></svg></div>', 
          autoplay: false,
          infinite: true,
          autoplaySpeed: 3000,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 4,
                 slidesToScroll: 4
              }
            },
        {
            breakpoint: 767,
            settings: {
              slidesToShow: 3, 
               slidesToScroll: 3, 
            }
          } ,{
              breakpoint: 400,
              settings: {
                slidesToShow: 2, 
                slidesToScroll: 2
              }
            }
          
        ]
      });
 }


if($('.video_slider').length > 0){
    $('.video_slider').slick({
          slidesToShow:4,
          slidesToScroll: 4, 
          rows:2,
          dots: true,    		
          speed: 1000,        
          // appendArrows: ".slider-arrows-dots",
          arrows: false,
          prevArrow: '<div title="Previous" class="custom-left custom-arrow trans"><svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.5303 0.307561C8.82319 0.600454 8.82319 1.07533 8.5303 1.36822L2.0103 7.88822C1.53319 8.36533 1.53319 9.15045 2.0103 9.62756L8.5303 16.1476C8.82319 16.4405 8.82319 16.9153 8.5303 17.2082C8.2374 17.5011 7.76253 17.5011 7.46964 17.2082L0.949636 10.6882C-0.113257 9.62533 -0.113258 7.89045 0.949636 6.82756L7.46964 0.307561C7.76253 0.0146673 8.2374 0.0146673 8.5303 0.307561Z" fill="#000"/></svg></div>',
          nextArrow: '<div title="Next" class="custom-right custom-arrow trans"><svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.379582 0.307561C0.672475 0.0146673 1.14735 0.0146673 1.44024 0.307561L7.96024 6.82756C9.02314 7.89045 9.02314 9.62533 7.96024 10.6882L1.44024 17.2082C1.14735 17.5011 0.672475 17.5011 0.379582 17.2082C0.0866888 16.9153 0.0866888 16.4405 0.379582 16.1476L6.89958 9.62756C7.37669 9.15045 7.37669 8.36533 6.89958 7.88822L0.379582 1.36822C0.0866888 1.07533 0.0866888 0.600454 0.379582 0.307561Z" fill="#000"/></svg></div>', 
          autoplay: false,
          infinite: true,
          autoplaySpeed: 3000,
          responsive: [
            {
              breakpoint: 1366,
              settings: {
                slidesToShow: 3, 
                slidesToScroll: 3
              }
            },
        {
            breakpoint: 767,
            settings: {
              slidesToShow: 2, 
              slidesToScroll: 2
            }
          },
        {
            breakpoint: 480,
            settings: {
              slidesToShow: 1, 
              slidesToScroll: 1
            }
          }
          
        ]
      });
 }





function VideoPlayer(url) { 
   var video = url;

  $('.popup').addClass('open');
  $("#myIframe").attr("src" , video); 
}
function removePopup() {
  // alert();
  $('.popup').removeClass('open');
  $("#myIframe").attr("src" , ''); 
  
}
  



 
